var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.666626C15.1826 0.666626 18.2348 1.93091 20.4853 4.18134C22.7357 6.43178 24 9.48403 24 12.6666C24 16.7653 21.7653 20.12 19.4107 22.5266C18.234 23.7158 16.9504 24.7941 15.576 25.748L15.008 26.1346L14.7413 26.312L14.2387 26.632L13.7907 26.9053L13.236 27.228C12.8593 27.4423 12.4334 27.5551 12 27.5551C11.5666 27.5551 11.1407 27.4423 10.764 27.228L10.2093 26.9053L9.516 26.4786L9.26 26.312L8.71333 25.948C7.23064 24.9444 5.84942 23.7985 4.58933 22.5266C2.23467 20.1186 0 16.7653 0 12.6666C0 9.48403 1.26428 6.43178 3.51472 4.18134C5.76515 1.93091 8.8174 0.666626 12 0.666626ZM12 8.66663C11.4747 8.66663 10.9546 8.77009 10.4693 8.97111C9.98396 9.17213 9.54301 9.46676 9.17157 9.8382C8.80014 10.2096 8.5055 10.6506 8.30448 11.1359C8.10346 11.6212 8 12.1413 8 12.6666C8 13.1919 8.10346 13.7121 8.30448 14.1974C8.5055 14.6827 8.80014 15.1236 9.17157 15.4951C9.54301 15.8665 9.98396 16.1611 10.4693 16.3621C10.9546 16.5632 11.4747 16.6666 12 16.6666C13.0609 16.6666 14.0783 16.2452 14.8284 15.4951C15.5786 14.7449 16 13.7275 16 12.6666C16 11.6058 15.5786 10.5883 14.8284 9.8382C14.0783 9.08805 13.0609 8.66663 12 8.66663Z",
    fill: "#FF8C42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainMarker);
export default __webpack_public_path__ + "static/media/main-marker.114e25255c7ec3b3af4368fd87c6a3ab.svg";
export { ForwardRef as ReactComponent };